import { Earth } from "lucide-react";
import FolderView from "@/components/FolderView";

const FOLDERS = ["Africa", "Europe", "Asia", "North America", "South America", "Oceania"];

export default function Continental() {
  return (
    <div className="p-6 max-w-6xl mx-auto">
      <div className="mb-8">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-12 h-12 bg-gradient-to-br from-amber-500 to-orange-600 rounded-xl flex items-center justify-center">
            <Earth className="w-6 h-6 text-white" />
          </div>
          <div>
            <h1 className="font-['Barlow_Condensed'] text-3xl font-bold text-app tracking-wide">
              CONTINENTAL
            </h1>
            <p className="text-app">Continental intelligence & regional documentation</p>
          </div>
        </div>
      </div>

      <FolderView subHub="continental" folders={FOLDERS} icon={Earth} color="amber" />
    </div>
  );
}
